export enum IncotermType {
  DDP = 'DDP',
  DDU = 'DDU',
  DAP = 'DAP',
  IOSS = 'IOSS',
}
